/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust2_PInputs */

const es_landing_trust2_p = /** @type {(inputs: Landing_Trust2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Del papeleo gestionado por nosotros, de principio a fin.`)
};

const gl_landing_trust2_p = /** @type {(inputs: Landing_Trust2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do papel xestionado por nós, de principio a fin.`)
};

const en_landing_trust2_p = /** @type {(inputs: Landing_Trust2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of paperwork handled by us, start to finish.`)
};

/**
* | output |
* | --- |
* | "Of paperwork handled by us, start to finish." |
*
* @param {Landing_Trust2_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust2_p = /** @type {((inputs?: Landing_Trust2_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust2_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust2_p(inputs)
	if (locale === "en") return en_landing_trust2_p(inputs)
	return es_landing_trust2_p(inputs)
});